{
    "FormEngineHttpRequestWfl": {
        "title": "Http Request",
        "description": "Transport Formdata via HTTP Request"
    },
    "mask": {
        "FormEngineHttpRequestWfl": {
            "description": "Description",
            "url": "Url",
            "method": "Method",
            "authGroupTitle": "Authorization",
            "requestGroupTitle": "Request",
            "responseType": "Response Type",
            "sourceType": "Source Type",
            "storeResultAs": "Result Path",
            "storeResultAsPlaceholder": "e.g. result",
            "storeErrorAs": "Error path",
            "storeErrorAsPlaceholder": "z.B. error"
        }
    }
}